<label class="fw-bold">{{localize(langSection.UserAccessHistory, langText.SearchChangeHistory)}}</label>
<div class="input-group-text">
    <input class="form-control rounded-0 border-dark" [(ngModel)]="historySearchString"
      (input)="searchForHistory()" />
    <button aria-label="Search History" class="btn border-dark rounded-0 bg-green" type="button"
      (click)="clearHistorySearch()"><span class="{{iconClass}}"></span></button>
  </div>
